module.exports = __webpack_public_path__ + "img/age-confirmation-bg.dd74160b.svg";